import { API_EMC } from 'Constants/client-modules';
import * as ACTION_TYPES from './types';

export function getDigiType() {
  return {
    types: [
      ACTION_TYPES.EMC_DIGI_TYPES_REQUESTED,
      ACTION_TYPES.EMC_DIGI_TYPES_SUCCEED,
      ACTION_TYPES.EMC_DIGI_TYPES_FAILED,
    ],
    promise: client => client.get('/digi-types/'),
    options: {
      clientName: API_EMC,
    },
  };
}
